import React from 'react';
import {
  Box,
  Container,
  Text,
  VStack,
  HStack,
  Grid,
  GridItem,
  Button,
  Link,
  Image,
} from '@chakra-ui/react';
import logoRF from '../utils/images/logo.png';
import ContactButton from '../utils/ContactButton';

const Footer = () => {
  const contact = {
    email: process.env.REACT_APP_EMAIL || 'contact@resterenfrance.fr',
    workingHours: process.env.REACT_APP_WORKING_HOURS || 'Lun–Ven 9:00–20:00',
  };

  return (
    <Box as="footer" bg="linear-gradient(135deg, #2c3e50 0%, #34495e 100%)" color="white" py={{ base: 12, lg: 16 }}>
      <Container maxW="1200px" px={5}>
        {/* Footer Content */}
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
          gap={{ base: 8, lg: 10 }}
          mb={10}
        >
          {/* Company Info */}
          <GridItem>
            <VStack align="center" spacing={6} textAlign="center">
              <Image src={logoRF} alt="Rester en France" h={{ base: '48px', md: '56px' }} objectFit="contain" />
              <VStack align="center" spacing={4} w="100%">
                <ContactButton />
                <HStack spacing={3} justify="center">
                  <Text color="white" fontWeight={600}>Email :</Text>
                  <Link href={`mailto:${contact.email}`} color="white" _hover={{ color: 'white', opacity: 0.85 }}>
                    {contact.email}
                  </Link>
                </HStack>
                <HStack spacing={3} justify="center">
                  <Text color="white" fontWeight={600}>Horaires :</Text>
                  <Text color="white">
                    {contact.workingHours}
                  </Text>
                </HStack>
              </VStack>
            </VStack>
          </GridItem>

          {/* Pages */}
          <GridItem>
            <VStack align="center" spacing={5} textAlign="center">
              <Text fontSize="lg" fontWeight={700} color="white">
                Pages
              </Text>
              <VStack align="center" spacing={3}>
                <Link href="/" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Accueil
                </Link>
                <Link href="/contact" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Contact
                </Link>
                <Link href="/mentions-legales" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Mentions légales
                </Link>
                <Link href="/confidentialite" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Confidentialité
                </Link>
                <Link href="/cookies" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85, transform: 'translateY(-2px)' }} transition="all 0.3s ease">
                  Cookies
                </Link>
              </VStack>
            </VStack>
          </GridItem>
        </Grid>

        {/* Company description */}
        <Box maxW="900px" mx="auto" textAlign="center" mb={8}>
          <Text color="white" fontSize={{ base: 'sm', md: 'md' }} opacity={0.95}>
            Rester en France – votre accompagnement dédié pour toutes vos démarches de titres de séjour et de visas en France.
          </Text>
          <Text mt={2} color="white" fontSize={{ base: 'sm', md: 'md' }} opacity={0.9}>
            Une équipe expérimentée à vos côtés pour simplifier vos procédures et obtenir rapidement vos justificatifs officiels.
          </Text>
        </Box>

        {/* Footer Bottom */}
        <Box
          borderTop="1px solid"
          borderColor="rgba(255, 255, 255, 0.1)"
          pt={5}
        >
          <VStack spacing={3} align="center" textAlign="center" w="100%">
            <Text color="white" fontSize="sm">
              © {new Date().getFullYear()} Rester en France. Tous droits réservés.
            </Text>
            <HStack spacing={5} justify="center">
              <Link href="/mentions-legales" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85 }}>
                Mentions légales
              </Link>
              <Link href="/confidentialite" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85 }}>
                Confidentialité
              </Link>
              <Link href="/cookies" color="white" fontSize="sm" _hover={{ color: 'white', opacity: 0.85 }}>
                Cookies
              </Link>
            </HStack>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
